import moment from "moment";
import {adddocumentary, followOrderType, getUserInfo, studentTraceType} from "@/server/api.js";
import {Toast} from "vant";
import {addressBar} from "@/utils/public";
import {wxConfig} from "@/views/fastReply/js/config";

export default {
    data() {
        return {
            typedname: "",//学员类型input字段
            typedid: "",
            zhiliang: '',//学员质量id选中
            studentZhiLiang: '',//学员质量描述
            remark: "",//备注
            username: "",
            nexttracetime: "",
            planstudytime: "",
            columnsType: [],//学员类型列表
            columnsZhiLiang: [],//学员质量列表
            showPicker: false,//学员类型弹框开关
            showPickerZhiLiang: false,//学员质量开关
            showCalendar: false,//
            planCalendar: false,//预计学习弹框开关
            nextCalendar: false,//下次跟单弹框开关
            showPickerFirstLevel: false,//一级分类开关
            showPickerSecondLevel: false,//一级分类开关
            showPickerThirdLevel: false,//一级分类开关
            showMess: false,
            routeParams: {},
            firstLevel: [],//一级分类列表
            secondLevel: [],//二级
            thirdLevel: [],//三级
            firstLevelId: '',
            secondLevelId: '',
            thirdLevelId: '',
            firstLevelName: '',//一级name
            secondLevelName: '',//二级name
            thirdLevelName: '',
            userId: '',
            zsUserid: '',
            windowurl:
                window.location.href.split("?")[0] || "http://tm-qw.1000phone.net/quicklyOrder",
            jsList: [
                "getCurExternalContact",
                'closeWindow'
            ],
            wechatUserId: '',
            // wechatUserId: "wmPpUqDAAAYfkQaLVmFJQjRCmSsIK9TQ",
            isLimit: false,
            infoObj: {}
        };
    },
    async mounted() {
        if (localStorage.getItem("token")) {
            await this.studentZhiL();
            wxConfig(this.windowurl, this.jsList).then(() => {
                this.userId = localStorage.getItem("userid");
                this.zsUserid = localStorage.getItem("zsUserId");
                this.hasuserid();
            });
        } else {
            addressBar("token", this.windowurl);
        }
    },
    methods: {
        //学员类型
        async getTracelist() {
            let res = await followOrderType({id: 74});
            if (res.code !== '200') return Toast.fail(res.msg);
            this.columnsType = [...res.data];
        },

        // 用户详情
        getUserInfos() {
            let formdata = new FormData();
            let that = this;
            formdata.append("userId", this.wechatUserId);
            getUserInfo(formdata).then((res) => {
                that.infoObj = res.data;
                if(that.infoObj.askId){
                    that.isLimit = true
                }else{
                    that.$notify({
                        type: 'warning',
                        message: '此学员未进招生系统，无法进行跟单',
                        duration: 3500,
                        onClose: function () {
                            wx.closeWindow();
                        }
                    });
                }
                // if (that.infoObj.wechatId === that.userId) {
                //     that.isLimit = true;
                // } else if (that.infoObj.kefuId === JSON.stringify(that.zsUserid)) {
                //     that.isLimit = true;
                // } else if (that.infoObj.operator === JSON.stringify(that.zsUserid)) {
                //     that.isLimit = true;
                // } else if (that.infoObj.helpStudyIdList.includes(that.zsUserid)) {
                //     that.isLimit = true;
                // } else {
                //     that.$notify({
                //         type: 'warning',
                //         message: '您不是此学员咨询师/协助咨询师/录入人无法进行跟单',
                //         duration: 3500,
                //         onClose: function () {
                //             wx.closeWindow();
                //         }
                //     });

                // }
                if (that.isLimit) {
                    that.getTracelist();
                    // that.studentZhiL();
                    that.getStudentType(0, 1);
                }
            });
        },

        hasuserid() {
            let that = this;
            // console.log(location.href);
            wx.invoke("getCurExternalContact", {}, function (res) {
                console.log(res);
                if (res.userId) {
                    that.wechatUserId = res.userId;
                    that.getUserInfos();
                }
            });
        },


        //学员分类
        async getStudentType(partId, level) {
            let res = await studentTraceType({partId: partId});
            if (res.code !== '200') return Toast.fail(res.msg);
            if (level === 1) {
                this.firstLevel = res.data;
            } else if (level === 2) {
                this.secondLevel = res.data;
            } else {
                this.thirdLevel = res.data;
            }
        },
        //打开二级分类
        openSecondLevel() {
            if (this.secondLevel.length) {
                this.showPickerSecondLevel = true;
            }
        },

        //打开三级分类
        openThirdLevel() {
            if (this.thirdLevel.length) {
                this.showPickerThirdLevel = true;
            }
        },
        //学员质量
        async studentZhiL() {
            let res = await followOrderType({id: 5354});
            if (res.code !== '200') return Toast.fail(res.msg);
            this.columnsZhiLiang = [...res.data.reverse()];
        },
        onSubmit() {
            let {nexttracetime, planstudytime, remark, zhiliang} = this;
            let params = {
                type: this.typedid,
                askid: this.infoObj.askId,
                // kefuid: this.infoObj.kefuId,
                kefuid:+this.zsUserid,
                remark,
                zhiliang,
                stair: this.firstLevelId,
                foxbase: this.secondLevelId,
                threeLevel: this.thirdLevelId,
                nexttracetime,
                planstudytime,
            };
            // http://localhost:8080/addRecord?askId=3770425&kefuId=17185
            adddocumentary(params).then((res) => {
                if (res.code !== "200") return Toast.fail(res.msg);
                Toast.success("添加成功");
                wx.closeWindow();

            });
        },
        //学员类型选择确认
        onConfirmStudentType(value) {
            this.typedname = value.dname;
            this.typedid = value.did;
            this.showPicker = false;
        },
        //学员质量选择确认
        onConfirmZhiLiang(value) {
            this.studentZhiLiang = value.dname;
            this.zsZhiliang = value.did;
            this.showPickerZhiLiang = false;
        },
        //下次跟单确认选择
        nextonConfirm(date) {
            this.nexttracetime = moment(date).format("YYYY-MM-DD HH:mm:ss");
            this.nextCalendar = false;
        },
        //预计学习时间
        dateonConfirm(date) {
            this.planstudytime = moment(date).format("YYYY-MM-DD HH:mm:ss");
            this.planCalendar = false;
        },
        //一级分类
        async onConfirmFirstLevel(val) {
            this.showPickerFirstLevel = false;
            this.firstLevelId = val.id;
            this.firstLevelName = val.typeName;
            await this.getStudentType(val.id, 2);
        },
        async onConfirmSecondLevel(val) {
            this.showPickerSecondLevel = false;
            this.secondLevelName = val.typeName;
            this.secondLevelId = val.id;
            await this.getStudentType(val.id, 3);
        },
        onConfirmThirdLevel(val) {
            this.thirdLevelId = val.id;
            this.thirdLevelName = val.typeName;
            this.showPickerThirdLevel = false;
        },

    },
};
